export const buildBasicInfoDirectionsMapUrl = ({
  key,
  origin,
  destination,
  waypoints = [],
}) => {
  if (!key || !origin || !destination) {
    return null
  }

  const queryParams = {
    key,
    origin,
    destination,
    maptype: 'roadmap',
  }

  if (Array.isArray(waypoints) && waypoints.length) {
    queryParams.waypoints = waypoints.join('|')
  }

  return `https://www.google.com/maps/embed/v1/directions?${Object.keys(queryParams)
    .map(paramKey => `${paramKey}=${queryParams[paramKey]}`)
    .join('&')}`
}

export default buildBasicInfoDirectionsMapUrl
